<template>
	<v-layout row class="perfil-paciente">
		<v-flex xs12 md3>
			<v-card class="card-paciente">
				<v-card-title class="text-h4 primary-text mb-3">
					<v-icon @click.prevent="regresar"> chevron_left </v-icon>
					Paciente
					<v-spacer> </v-spacer>
					<v-icon
						v-if="datosPaciente.PDF"
						@click.prevent="abrirPDF(datosPaciente.PDF)"
						color="primary"
						>picture_as_pdf</v-icon
					>
					<v-icon
						class="ml-2"
						@click.prevent="editarPaciente"
						color="primary"
						>edit</v-icon
					>
				</v-card-title>
				<v-card-text class="mb-3 datos-perfil">
					<v-layout row>
						<v-flex xs5 text-right class="pl-5">
							<v-avatar color="primary" size="75">
								<span
									class="
										white--text
										text-h3
										font-weight-medium
									"
								>
									{{ datosPaciente.Iniciales }}
								</span>
							</v-avatar>
						</v-flex>
						<v-flex xs7>
							<div class="font-weight-bold">
								{{ datosPaciente.Nombres }}
							</div>
							<div>
								{{ datosPaciente.PrimerApellido }}
							</div>
							<div>{{ datosPaciente.Edad }} años</div>
							<div
								class="success--text"
								v-if="datosPaciente.Activo"
							>
								Activo
							</div>
							<div class="error--text" v-else>Baja</div>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>

			<v-card class="mt-3 mb-3 card-historial">
				<v-card-title class="text-h4 primary-text mb-3">
					Historial de visitas
					<v-spacer> </v-spacer>
					<v-icon
						@click.prevent="nuevaVisita"
						color="primary"
						v-if="datosPaciente.CrearVisita !== false"
						>add</v-icon
					>
				</v-card-title>
				<v-card-text>
					<v-simple-table height="20vh">
						<tbody>
							<tr
								class="link"
								v-for="visita in visitas"
								:key="visita.VisitaID"
								@click.prevent="cargarVisita(visita.VisitaID)"
							>
								<td>{{ visita.Fecha }}</td>
								<td class="text-right">
									<v-icon>chevron_right</v-icon>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
				</v-card-text>
			</v-card>

			<v-card class="card-historial">
				<v-card-title class="text-h4 primary-text mb-3">
					Historial clínico
					<v-spacer> </v-spacer>
					<v-icon
						@click.prevent="nuevaHistoriaClinica"
						color="primary"
						v-if="datosPaciente.CrearHistoriaClinica !== false"
						>add</v-icon
					>
				</v-card-title>
				<v-card-text>
					<v-simple-table height="20vh">
						<tbody>
							<tr
								v-for="historial in historialesClinicos"
								:key="historial.HistoriaClinicaID"
							>
								<td
									class="link"
									@click.prevent="
										abrirHistoriaClinica(historial)
									"
								>
									{{ historial.Fecha }}
								</td>
								<td class="text-right">
									<v-icon
										v-if="historial.PDF"
										@click.prevent="abrirPDF(historial.PDF)"
										color="primary"
										>picture_as_pdf</v-icon
									>
									<v-icon
										@click.prevent="
											abrirHistoriaClinica(historial)
										"
										class="ml-2"
										>chevron_right</v-icon
									>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs12 md9 class="datos-visita">
			<v-alert
				v-if="!visitaSeleccionada"
				border="right"
				color="blue-grey"
				dark
			>
				No hay ninguna visita seleccionada
			</v-alert>
			<v-card class="card-visita" v-else>
				<v-card-title class="text-h4 primary-text mb-3">
					Datos de la visita
				</v-card-title>
				<v-card-text class="contenido-visita">
					<div>
						<v-layout row wrap>
							<v-flex
								xs12
								class="
									primary--text
									text-h4
									mt-3
									mb-3
									font-weight-medium
								"
							>
								Fecha: {{ visitaActual.Fecha }}
							</v-flex>
						</v-layout>
						<v-container grid-list-md class="pasos">
							<v-layout row>
								<v-flex
									@click.prevent="irPaso(1)"
									xs6
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(1)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(1, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">Antroprometría</div>
									</div>
								</v-flex>
								<v-flex
									xs6
									@click.prevent="irPaso(2)"
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(2)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(2, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">Bioquímicos</div>
									</div>
								</v-flex>
								<v-flex
									@click.prevent="irPaso(3)"
									xs6
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(3)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(3, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">Clínicos</div>
									</div>
								</v-flex>
								<v-flex
									@click.prevent="irPaso(4)"
									xs6
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(4)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(4, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">
											Dietéticos y Estilo de Vida
										</div>
									</div>
								</v-flex>
								<v-flex
									@click.prevent="irPaso(5)"
									xs6
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(5)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(5, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">
											Análisis y Plan Terapéutico
										</div>
									</div>
								</v-flex>
								<v-flex
									@click.prevent="irPaso(6)"
									xs6
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(6)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(6, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">
											Nota de Evolución Interna
										</div>
									</div>
								</v-flex>
								<v-flex
									@click.prevent="irPaso(7)"
									xs6
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(7)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(7, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">
											Nota de Evolución Firma px
										</div>
									</div>
								</v-flex>
								<v-flex
									@click.prevent="irPaso(8)"
									xs6
									class="
										primary--text
										text-h4
										font-weight-bold
									"
								>
									<div
										class="paso-visita"
										:class="{
											desactivada: !pasoCompletado(8)
										}"
									>
										<v-icon
											color="success"
											v-if="pasoCompletado(8, true)"
											>check_circle</v-icon
										>
										<v-icon color="warning" v-else
											>watch_later</v-icon
										>
										<div class="pl-4">
											Nota de Evolución Médico
										</div>
									</div>
								</v-flex>
							</v-layout>
						</v-container>
					</div>
					<div class="mt-3">
						<v-card class="adjuntos">
							<v-card-title>
								Adjuntos
								<v-spacer> </v-spacer>
								<v-icon color="primary">add</v-icon>
							</v-card-title>
							<v-card-text>
								<div
									@click="abrirAdjunto(adjunto)"
									class="adjunto primary text-center"
									v-for="adjunto in visitaActual.Adjuntos"
									:key="adjunto.VisitaAdjuntoID"
								>
									<div class="acciones">
										<v-icon color="white">close</v-icon>
									</div>
									<div>
										<v-icon color="white" size="30"
											>description</v-icon
										>
									</div>
									<div>{{ adjunto.Nombre }}</div>
								</div>
							</v-card-text>
						</v-card>
					</div>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import ServicioPacientes from "../../services/pacientes";
import ServicioHistorialClinico from "../../services/historialClinico";

export default {
	name: "perfilPaciente",
	data() {
		return {
			datosPaciente: {},
			visitas: [],
			historialesClinicos: [],
			visitaSeleccionada: false,
			visitaActual: {
				Pasos: {},
				Adjuntos: [],
				Fecha: ""
			}
		};
	},
	methods: {
		pasoCompletado(paso, progreso) {
			if (this.visitaActual.Pasos.PasoActual === 0) {
				return true;
			}
			return progreso
				? this.visitaActual.Pasos.PasoActual === 8 ||
						this.visitaActual.Pasos.PasoActual > paso
				: this.visitaActual.Pasos.PasoActual >= paso;
		},
		abrirVisita(visita) {},
		irPaso(paso) {
			if (!this.pasoCompletado(paso)) {
				return;
			}
			const pasos = [
				"",
				"antropometria",
				"bioquimicos",
				"clinicos",
				"dieteticos-y-estilo-vida",
				"analisis-y-plan-terapeutico",
				"nota-evolucion-interna",
				"nota-evolucion-firma",
				"nota-evolucion-medico"
			];
			const rutaPaso = pasos[paso];
			this.$router.push(
				`/nutricion/visita/${this.visitaActual.VisitaID}/${rutaPaso}`
			);
		},
		abrirPDF(pdf) {
			window.open(this.config.RutaPDF + pdf, "_blank");
		},
		editarPaciente() {
			this.$router.push(
				"/nutricion/editar-paciente/" + this.$route.params.pacienteId
			);
		},
		regresar() {
			this.$router.back();
		},
		async cargarVisita(visitaId) {
			const res = await ServicioPacientes.getDatosVisita(visitaId);
			this.visitaActual.Pasos = res.data.data.Table0[0];
			this.visitaActual.Adjuntos = res.data.data.Table1;
			this.visitaActual.Fecha = "visita.Fecha";
			this.visitaActual.VisitaID = visitaId;
			this.visitaSeleccionada = true;
			if (visitaId != this.$route.params.visitaId) {
				this.$router.replace(
					`/nutricion/perfil-paciente/${this.$route.params.pacienteId}/${visitaId}`
				);
			}
		},
		abrirAdjunto(adjunto) {
			window.open(this.config.RutaAdjuntos + adjunto.Archivo, "_blank");
		},
		abrirHistoriaClinica(historial) {
			this.$router.push(
				"/nutricion/historial-clinico/" + historial.HistoriaClinicaID
			);
		},
		async nuevaHistoriaClinica() {
			const res = await ServicioHistorialClinico.crear(
				this.$route.params.pacienteId
			);
			if (res.data.result === 1) {
				const historiaClinicaId =
					res.data.data.Table0[0].HistoriaClinicaID;

				this.$router.push(
					"/nutricion/historial-clinico/" + historiaClinicaId
				);
			} else {
				this.$root.mensajeError = "Error al crear: " + res.data.message;
			}
		},
		async nuevaVisita() {
			const res = await ServicioPacientes.crearVisita(
				this.$route.params.pacienteId
			);
			if (res.data.result === 1) {
				const visita = res.data.data.Table0[0];
				this.cargarPerfil();
				this.cargarVisita(visita);
			} else {
				this.$root.mensajeError = "Error al crear: " + res.data.message;
			}
		},
		async cargarPerfil() {
			const pacienteId = this.$route.params.pacienteId;
			const res = await ServicioPacientes.getPerfilPaciente(pacienteId);
			this.datosPaciente = res.data.data.Table0[0];
			this.visitas = res.data.data.Table1;
			this.historialesClinicos = res.data.data.Table2;
			this.datosPaciente.Iniciales = this.datosPaciente.Nombres[0];
			this.datosPaciente.Iniciales += this.datosPaciente.PrimerApellido[0];
			let visitaId;
			if (this.$route.params.visitaId) {
				visitaId = this.$route.params.visitaId;
			} else if (this.visitas.length) {
				visitaId = this.visitas[0].VisitaID;
			}
			if (visitaId) {
				await this.cargarVisita(visitaId);
			}
		}
	},
	async mounted() {
		await this.cargarPerfil();
	}
};
</script>
<style scoped>
.card-visita {
	height: calc(100% - 20px);
}
.perfil-paciente,
.datos-visita {
	height: 100%;
}
.card-historial {
	height: 35%;
}
.card-paciente {
	height: 25%;
}
.v-card__title {
	background: #d3d3d3;
	color: #878886;
	font-weight: bold;
}
.adjuntos .v-card__title {
	background: #f3f3f3;
}
.adjuntos .v-card__text {
	background: #f3f3f3;
}
.paso-visita {
	padding: 15px !important;
	display: flex;
	font-size: 24px !important;
	border: 1px solid #d3d3d3;
	border-radius: 10px;
	align-items: center;
	cursor: pointer;
}
.paso-visita:hover {
	background: #f3f3f3;
}
.paso-visita .v-icon {
	font-size: 40px !important;
}
.desactivada {
	background: #f9f9f9 !important;
	color: #d3d3d3;
	cursor: default;
}
.contenido-visita {
	height: calc(100% - 58px);
	display: flex;
	justify-content: space-between;
	flex-direction: column;
}
.adjuntos .v-card__text {
	background: #f3f3f3;
	padding: 5px;
	margin-bottom: 20px;
	display: flex;
}
.adjunto {
	margin-left: 10px;
	width: 130px;
	padding: 10px;
	border: 1px solid #d3d3d3;
	border-radius: 5px;
	color: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}
.adjunto .acciones {
	width: 100%;
	justify-content: right;
	justify-items: right;
	display: flex;
}
.pasos {
	max-height: 40vh;
	overflow: auto;
}
.datos-perfil {
	justify-items: center;
}
</style>
